
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import loadedQuestions from '../assets/json/questions.json';
export default {
  mounted() {
    console.log('componentMounted', this);
  },
  data: function () {
    return {
      index: 0,
      totalQuestions: loadedQuestions,
      que: loadedQuestions[0]
    };
  },
  methods: {
    loadQuestion: function () {
      if (this.index == 4) {
        this.$f7.dialog.alert('Quiz Completed');
      }
      var self = this;
      self.$setState({ index: self.index + 1 });
      self.$setState({ que: loadedQuestions[self.index] });
      this.enableOptions();
    },
    checkQuestion: function (e) {
      console.log('o' + this.que.a + e.target.id);
      if ('o' + this.que.a == e.target.id) {
        e.target.classList.add('correct');
        this.updateAnswerTracker('correct');
      } else {
        e.target.classList.add('wrong');
        this.updateAnswerTracker('wrong');
      }
      this.disableOptions();
    },
    updateAnswerTracker: function (classNam) {
      this.$$('#t' + this.index).addClass(classNam);
    },
    disableOptions: function () {
      for (let i = 0; i < this.que.o.length; i++) {
        this.$$('#o' + i).addClass('disable');
        if (i == this.que.a) {
          this.$$('#o' + i).addClass('correct');
        }
      }
    },
    enableOptions: function () {
      for (let i = 0; i < this.que.o.length; i++) {
        this.$$('#o' + i).removeClass('disable');
        this.$$('#o' + i).removeClass('correct');
        this.$$('#o' + i).removeClass('wrong');
      }
    }
  },
  id: '5812e2fd58',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page">\r\n    <div class="navbar navbar-transparent">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner sliding">\r\n        <div class="left">\r\n          <a href="#" class="link back">\r\n            <i class="icon icon-back"></i>\r\n            <span class="if-not-md">Back</span>\r\n          </a>\r\n        </div>\r\n        <div class="title">Quiz Page</div>\r\n      </div>\r\n    </div>\r\n    <div class="page-content">\r\n      <div class="block">\r\n        <div class="row no-gap">\r\n          <div class="block-header col-100 small-25  ">\r\n            <div class=""> Question ';
      r += c(ctx_1.index + 1, ctx_1);
      r += ' of ';
      r += c(ctx_1.totalQuestions.length, ctx_1);
      r += '\r\n            </div>\r\n          </div>\r\n          <div class="col-100 small-50">\r\n            <div class="answers-tracker">\r\n              ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.totalQuestions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n              <div id="t';
          r += c(data_2 && data_2.index, ctx_2);
          r += '"></div>\r\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <div class="block">\r\n        <div class="question">';
      r += c(ctx_1.que.q, ctx_1);
      r += '</div>\r\n        <div class="options">\r\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.que.o, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n          <div id="o';
          r += c(data_2 && data_2.index, ctx_2);
          r += '" class="option1" @click="checkQuestion">';
          r += c(data_2 && data_2.index, ctx_2);
          r += ' ';
          r += c(ctx_2, ctx_2);
          r += '</div>\r\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n        </div>\r\n      </div>\r\n\r\n      <div class="block">\r\n        <div class="row btn-row">\r\n            \r\n          <button class="col-60 xsmall-50 small-33 medium-25 xlarge-20 button button-fill button-round button-raised button-large" @click="loadQuestion">\r\n            Next\r\n          </button>\r\n      </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  style: `
  .block {
    margin-top: 0px;
    margin-bottom: 0px;
  }
.btn-row{
  display: flex;
  align-items: center;
  justify-content: center;
} 
  
`,
  styleScoped: false
};
    